import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import { useState } from 'react';

export default function LatestUpdates() {
  const [activeTab, setActiveTab] = useState('all');
  const tabs = [
    { key: 'all', label: '全部' },
    { key: 'romance', label: '恋爱' },
    { key: 'fantasy', label: '奇幻' },
    { key: 'action', label: '动作' },
    { key: 'drama', label: '剧情' },
  ];

  const filtered = activeTab === 'all'
    ? [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, 8)
    : comics.filter(c => c.category === activeTab).slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">实时追踪韩漫最新章节更新</p>
          </div>
        </div>

        <div className="flex items-center gap-2 mb-6 overflow-x-auto pb-2 flex-wrap">
          {tabs.map(tab => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === tab.key
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-50 text-foreground-600 hover:bg-secondary-100 border border-background-200'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {filtered.map(comic => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画下拉式免费韩漫`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {comic.status === '连载中' && (
                  <div className="absolute top-2 right-2">
                    <span className="inline-block bg-accent-500 text-white text-[10px] font-semibold px-2 py-0.5 rounded-full">
                      连载
                    </span>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-white text-xs font-medium">
                    更新至第{comic.chapters}话
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-500">{comic.author}</span>
                <span className="text-xs text-accent-600">★ {comic.rating}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}